import React from "react";
import "./floatingwhatsapp.css";

const FloatingWhatsapp = () => {
  return (
    <a
      href="https://api.whatsapp.com/send?phone=917800780095&text=Hello%20HelperJi%21%20."
      className="floating"
      target="_blank"
      rel="noopener noreferrer"
    >
      <i className="fa fa-whatsapp float-button"></i>
    </a>
  );
};

export default FloatingWhatsapp;
